export const panelStyles = {
  maxWidth: '520px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  borderRadius: ({ shape }) => shape.radius.xl,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.s,
  overflow: 'hidden',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 14px 0',
};

export const closeButtonStyles = {
  width: '30px',
  height: '30px',
  padding: 0,
  color: ({ palette }) => palette.text.placeholder,
  '&:hover': {
    color: ({ palette }) => palette.text.primary,
  },
};

export const bodyStyles = {
  padding: '16px 14px',
};
